import React from 'react';
import { Option, OptionOnSelectData } from '@fluentui/react-components';
import { SettingItemDropdownProps } from './type';
import { SettingItemDropdownWrapper } from './styling';

function SettingItemDropdown({ onChange, options, settingValue }: SettingItemDropdownProps) {
  const handleOnChange = (_, data: OptionOnSelectData) => {
    onChange(data.optionValue);
  };

  const dropdownText =
    options.find((option) => option.value === settingValue)?.label || settingValue;

  return (
    <SettingItemDropdownWrapper onOptionSelect={handleOnChange} value={dropdownText}>
      {options.map(({ label, key, value }) => (
        <Option key={key} value={value}>
          {label}
        </Option>
      ))}
    </SettingItemDropdownWrapper>
  );
}

export default SettingItemDropdown;
